import { normalizeFields } from "@/forms/helpers";

export const model = normalizeFields({
  complaint: {
    type: "text",
    label: "Opisz w kilku słowach:",
    value: "",
    required: true,
    min: 6,
  },
});
